import { createFileRoute, redirect } from '@tanstack/react-router';

import { REDIRECT_URL_KEY } from '@/constants';

export const Route = createFileRoute('/logout')({
  beforeLoad: async ({ context: { auth } }) => {
    sessionStorage.removeItem(REDIRECT_URL_KEY);
    await auth.logout({ allSessions: true, redirectUrl: import.meta.env.VITE_LOGOUT_REDIRECT_URI });
    throw redirect({ to: '/login' });
  },
});
